"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var react_1 = __importStar(require("react"));
var ra_fetch_1 = require("ra-fetch");
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function indexParams(user, channel) {
    var params = {
        page: 1,
        paginate: 20,
        sort: 'name asc',
    };
    if (!user.is_admin) {
        params.channel_id = channel.id;
    }
    if (user.channel.role === 'coach') {
        params.role = 'player';
    }
    return params;
}
var List = function (_a) {
    var user = _a.user, _b = _a.channel, channel = _b === void 0 ? {} : _b;
    var _c = storybook_1.Hooks.useModal(), Modal = _c[0], setModal = _c[1], modalClose = _c[2];
    var _d = react_1.useState('name'), sortField = _d[0], setSortField = _d[1];
    var _e = react_1.useState('asc'), sortDirection = _e[0], setSortDirection = _e[1];
    var _f = ra_fetch_1.useApi('auth').index('users', indexParams(user, channel)), users = _f[0], setUsers = _f[1], params = _f[2], setParams = _f[3];
    var _g = storybook_1.Hooks.useSearch(params, setParams), search = _g[0], setSearch = _g[1];
    var Request = function (page) {
        setParams(__assign(__assign({}, params), { page: page }), page !== 1);
    };
    function onSort(newSortFields) {
        if (params.channel_id === undefined) {
            return;
        }
        var newSortField = Array.isArray(newSortFields) ? newSortFields[0] : newSortFields;
        var newSortDirection = 'asc';
        if (newSortField === sortField) {
            newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
        }
        setSortField(newSortField);
        setSortDirection(newSortDirection);
        var newSortObj = Array.isArray(newSortFields)
            ? newSortFields.map(function (field, i) { return field + " " + (i === 0 ? newSortDirection : 'asc'); })
            : newSortField + " " + newSortDirection;
        setParams(__assign(__assign({}, params), { sort: newSortObj }));
    }
    return react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-layouts-space' },
        react_1.default.createElement(Modal, null),
        react_1.default.createElement("div", { className: 'sm:flex items-center mb-4' },
            user.is_admin && react_1.default.createElement(storybook_1.Users.FilterChannel, { params: params, setParams: setParams }),
            react_1.default.createElement(storybook_1.Forms.Input, { className: 'mt-auto', placeholder: 'Zoeken...', value: search, onChange: setSearch })),
        users.meta.total === 0 && !users.loading &&
            react_1.default.createElement(storybook_1.Forms.New, { description: 'Je hebt nog geen gebruikers', label: 'Nieuwe Gebruiker', to: process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/users/create", icon: 'plus' }),
        users.data.length !== 0 && react_1.default.createElement(storybook_1.Users.List, { users: users, sortField: sortField, onSort: onSort, onDelete: function (current) { return setModal({
                content: function () { return react_1.default.createElement(storybook_1.Forms.DeleteModal, { onDelete: modalClose, records: users.data, setRecords: setUsers, title: 'gebruiker', route: user.is_admin ? 'users' : 'users.channels', api: 'auth', params: {
                        id: current.id,
                        channel_id: channel.id
                    } }); },
            }); } }),
        react_1.default.createElement(storybook_1.Lists.Lazyload, { loading: users.meta.current_page && users.loading, load: users.meta.current_page !== users.meta.last_page, onEnter: function () { return Request(users.meta.current_page + 1); } }));
};
exports.List = List;
exports.List.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    /**
     * The Params for the request
     */
    params: prop_types_1.default.object,
};
exports.List.defaultProps = {};
